import AccountOutlined from '../src/AccountOutlined';
export default AccountOutlined;
